import { render, staticRenderFns } from "./PermisoUnidadesOperativas.vue?vue&type=template&id=26c87947&"
import script from "./PermisoUnidadesOperativas.vue?vue&type=script&lang=js&"
export * from "./PermisoUnidadesOperativas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports